import { CartSheet } from "@/features/cart";
import { CreateDepositDialog, DepositPaymentDialog } from "@/features/deposits";
import { NotificationsSheet } from "@/features/notifications";
import { SearchDialog } from "@/features/search";
import { UploadFilesDialog } from "@/features/store-product";
import { InitiativeDialog } from "@/features/tickets";
import { WithdrawDialog } from "@/features/withdrawals";
import { BanNotificationDialog } from "@/shared/model/ban-notification";
import { useGlobalDialogs } from "@/shared/model/global-dialogs";
import { PenaltyNotificationDialog } from "@/shared/model/penalty-notification";
import { useSession } from "@/shared/model/session";

function AuthenticatedDialogs() {
  const { isOpen, close, data } = useGlobalDialogs();

  return (
    <>
      <CreateDepositDialog
        isOpen={isOpen("deposit")}
        onOpenChange={(open) => !open && close()}
      />
      <DepositPaymentDialog />
      <WithdrawDialog
        open={isOpen("withdraw")}
        onOpenChange={(open) => !open && close()}
        availableBalance={
          (data as { availableBalance: number } | null)?.availableBalance ?? 0
        }
      />
      <CartSheet
        isOpen={isOpen("cart")}
        onOpenChange={(open) => !open && close()}
      />
      <NotificationsSheet
        isOpen={isOpen("notifications")}
        onOpenChange={(open) => !open && close()}
      />
      <InitiativeDialog
        isOpen={isOpen("initiative")}
        onOpenChange={(open) => !open && close()}
      />
      <UploadFilesDialog />
    </>
  );
}

export function GlobalDialogs() {
  const { isAuthenticated } = useSession();
  const { isOpen, close } = useGlobalDialogs();

  return (
    <>
      <SearchDialog
        open={isOpen("search")}
        onOpenChange={(open) => !open && close()}
      />
      <BanNotificationDialog />
      <PenaltyNotificationDialog />
      {isAuthenticated && <AuthenticatedDialogs />}
    </>
  );
}
